import { EPermissoes } from '@/enums/ePermissoes';
import cadastro from './cadastro/routes';
import relatorios from './relatorios/routes';

const withTipoFornecimento = (routes: any[], utlTipoFornecimentoId: number): any[] =>
  routes.map((route) => ({
    ...route,
    meta: {
      ...route.meta,
      utlTipoFornecimentoId
    },
    children: route.children ? withTipoFornecimento(route.children, utlTipoFornecimentoId) : route.children
  }));

const routes = [
  {
    description: '4. Laudo de Cerâmica',
    path: 'laudo',
    name: 'laudoCeramica',
    component: () => import('@/views/controle-tecnologico/laudo/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoFornecimento: 'Ceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Laudo de Cerâmica',
    path: 'laudo/incluir/:tipoEnsaioId/:laboratorioId',
    name: 'laudoinsertCeramica',
    component: () => import('@/views/controle-tecnologico/laudo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'laudoCeramica',
      utlTipoFornecimentoId: 101,
      laudoOpcional: false,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: []
    }
  },
  {
    description: 'Edição de Laudo de Cerâmica',
    path: 'laudo/editar/:id/:tipoEnsaioId/:laboratorioId',
    name: 'laudoUpdateCeramica',
    component: () => import('@/views/controle-tecnologico/laudo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'laudoCeramica',
      utlTipoFornecimentoId: 101,
      laudoOpcional: false,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: []
    }
  },
  {
    description: 'Revisão de Laudo de Cerâmica',
    path: 'revisao-laudo',
    name: 'revisaoLaudoCeramica',
    component: () => import('@/views/controle-tecnologico/aprovacao-laudo/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Aprovacao_Laudo],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: '1. Recebimento de Cerâmica',
    path: 'recebimento',
    name: 'recebimentoceramica',
    component: () => import('@/views/utilidade/recebimento/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Lancamento_Recebimento],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Recebimento de Cerâmica',
    path: 'recebimento/incluir',
    name: 'recebimentoceramicainsert',
    component: () => import('@/views/utilidade/recebimento/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'recebimentoceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Lancamento_Recebimento]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Recebimento de Cerâmica',
    path: 'recebimento/editar/:id',
    name: 'recebimentoceramicaupdate',
    component: () => import('@/views/utilidade/recebimento/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'recebimentoceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Lancamento_Recebimento],
      grupos: []
    },
    goesToMenu: false
  },
  {
    description: '2. Aplicação de Cerâmica',
    path: 'aplicacao',
    name: 'aplicacaoceramica',
    component: () => import('@/views/utilidade/aplicacao-ambiente/Index.vue'),
    meta: {
      tipoFornecimento: 'ceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Lancamento_Aplicacao],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Aplicação de Cerâmica',
    path: 'aplicacao/incluir',
    name: 'inclusaoaplicacaoceramica',
    component: () => import('@/views/utilidade/aplicacao-ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'aplicacaoceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Lancamento_Aplicacao]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Aplicação de Cerâmica',
    path: 'aplicacao/editar/:protocolo',
    name: 'aplicacaoceramicaupdate',
    component: () => import('@/views/utilidade/aplicacao-ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'aplicacaoceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Lancamento_Aplicacao]
    },
    goesToMenu: false
  },
  {
    description: '3. Ensaio de Cerâmica',
    path: 'ensaio',
    name: 'ensaioceramica',
    component: () => import('@/views/utilidade/ensaio/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Lancamento_ResultadoEnsaios],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão/Edição de Ensaio de Cerâmica',
    path: 'ensaio/incluir',
    name: 'InclusaoEdicaoEnsaio',
    component: () => import('@/views/utilidade/ensaio/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: {
      parentRouteName: 'ensaioceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Lancamento_ResultadoEnsaios]
    }
  },
  {
    description: 'Estoque de Cerâmica',
    path: 'estoque',
    name: 'estoqueceramica',
    component: () => import('@/views/utilidade/estoque/Index.vue'),
    meta: {
      tipoFornecimento: 'Cerâmica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Estoque],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Lote de Cerâmica',
    path: 'lote',
    name: 'produtofornecedorloteceramica',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Lancamento],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Lote de Cerâmica',
    path: 'lote/incluir?produto=:utlProdutoId&fornecedor=:gesFornecedorId',
    name: 'produtofornecedorloteceramicainsert',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'produtofornecedorloteceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Lancamento]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Lote de Cerâmica',
    path: 'lote/editar/:id?produto=:utlProdutoId&fornecedor=:gesFornecedorId',
    name: 'produtofornecedorloteceramicaupdate',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'produtofornecedorloteceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Lancamento]
    },
    goesToMenu: false
  },
  {
    path: 'cadastro',
    description: 'Cadastro',
    goesToMenu: false,
    children: cadastro
  },
  {
    path: 'relatorios',
    description: 'Relatorios',
    goesToMenu: false,
    children: relatorios
  }
];

export default [
  {
    path: 'ceramica',
    description: 'Cerâmica',
    meta: {
      utlTipoFornecimentoId: 101
    },
    goesToMenu: false,
    children: withTipoFornecimento(routes, 101)
  }
];
